<template>
  <div>
    <div class="card">
      <div class="card-header" role="tab" :id="`sub-${dparent}-${index}`">
        <h5 class="mb-0">
          <a :class="{'fontInitial':isStaticMobilePage}" data-toggle="collapse" :data-parent="'#' + dparent" :href="`#${dparent}-${index}`"
             :aria-expanded="areaExpanded" :aria-controls="`${dparent}-${index}`" v-html="title">
          </a>
        </h5>
      </div>
      <div :id="`${dparent}-${index}`" :class="{'collapse': !isOpen, 'collapse show': isOpen}" role="tabpanel" :aria-labelledby="`sub-${dparent}-${index}`">
        <div class="card-block op_5">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['title', 'index', 'dparent', 'areaExpanded', 'isOpen'],
    computed: {
      isStaticMobilePage: function () {
        return this.$route.path === '/contact-us-mobile'
      }
    }
  }
</script>
<style scoped="scoped">
  .fontInitial {
    font-family: 'Source Sans Pro', sans-serif !important;
font-weight: 400;
  }

  .card-block {
    text-align: justify;
  }

  .description {
    background: #eee;
  }

  .custaccordian .card-header a {
    padding: 20px 0;
    text-transform: inherit;
  }
  .customised-prod-faqs .custaccordian .card-header a {
    padding: 14px 0;
    padding-right: 30px;
  }

  .custaccordian .card-block {
    padding: 5px 0px 20px 0;
  }
  .customised-prod-faqs .custaccordian .card-block {
    padding: 0px 0px 20px 0;
  }

  .custaccordian .card-header a[aria-expanded="true"]::before {
    color: #117a7a;
    top: 10px;
  }
  .customised-prod-faqs .custaccordian .card-header a[aria-expanded="true"]::before {
    color: #282d3f;
  }

  ul.coloredlistype li {
    text-indent: 0;
    padding-left: 15px;
  }

  .custaccordian .card-header a {
    padding-right: 30px;
  }

  @media screen and (max-width: 991px) {
    .custaccordian .card-header a {
      padding: 15px 30px 15px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// faqTab.vue?f138e4da